exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n", ""]);

// exports
exports.locals = {
	"narrowMax": "1000",
	"wideMax": "Infinity",
	"narrow": "narrow",
	"wide": "wide"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./resources/assets/sass/_variables.scss
// module id = /f4a
// module chunks = 2 3 4 5 6